/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Cancel_Order_Dialog_DescriptionInputs */

const en_orders_cancel_order_dialog_description = /** @type {(inputs: Orders_Cancel_Order_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will cancel the entire order and cannot be undone.`)
};

const es_orders_cancel_order_dialog_description = /** @type {(inputs: Orders_Cancel_Order_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto cancelara todo el pedido y no se puede deshacer.`)
};

/**
* | output |
* | --- |
* | "This will cancel the entire order and cannot be undone." |
*
* @param {Orders_Cancel_Order_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_order_dialog_description = /** @type {((inputs?: Orders_Cancel_Order_Dialog_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_Order_Dialog_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_order_dialog_description(inputs)
	return es_orders_cancel_order_dialog_description(inputs)
});